<template>
  <v-container fluid class="px-15 mx-15">
    <Alertas
      :notificacaoSocket="alertaSocket"
      :texto="alerta.texto"
      :tipo="alerta.tipo"
    ></Alertas>

    <v-form v-model="isValido">
      <v-row align="center">
        <v-col cols="12">
          <v-toolbar flat>
            <v-toolbar-title>| Rastreio de Produtos</v-toolbar-title>
          </v-toolbar>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroItem"
            :items="listaDeItens"
            :loading="!listaDeItens"
            :readonly="!listaDeItens"
            :no-data-text="loadingAutocomplete.noDataTextProduto"
            chips
            multiple
            label="Lista de Produtos em Estoque"
            autocomplete="off"
            prepend-icon="mdi-file-table"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeItem(data.item)"
              >
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.indicadorStatusFamilia"
            :items="listaDeFamilias"
            chips
            multiple
            label="Famílias de Produtos"
            autocomplete="off"
            prepend-icon="mdi-format-list-bulleted-type"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeFamilia(data.item)"
              >
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroFuncionario"
            :items="listaDeFuncionarios"
            :loading="!listaDeFuncionarios"
            :readonly="!listaDeFuncionarios"
            :no-data-text="loadingAutocomplete.noDataTextFuncionario"
            label="Funcionários"
            autocomplete="off"
            clearable
            prepend-icon="mdi-account-group"
          ></v-autocomplete>
        </v-col>

        <v-col v-if="$store.state.numeroEndereco == 93 || $store.state.numeroEndereco == 97 || $store.state.numeroEndereco == 128" cols="12">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.indicadorTipoDispensa"
            :items="listaTipoDispensa"
            chips
            multiple
            label="Tipo de Dispensa"
            autocomplete="off"
            prepend-icon="mdi-archive-settings"
          >
            <template v-slot:selection="data">
              <v-chip
                v-bind="data.attrs"
                :input-value="data.selected"
                close
                @click="data.select"
                @click:close="removeTipo(data.item)"
              >
                {{ data.item.text }}
              </v-chip>
            </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.descricaoCpf"
            :items="listaDePaciente"
            :loading="!listaDePaciente"
            :readonly="!listaDePaciente"
            :no-data-text="loadingAutocomplete.noDataTextPaciente"
            :search-input.sync="searchPaciente"
            clearable
            @keydown="buscarPacientes"
            label="Pacientes"
            autocomplete="off"
            prepend-icon="mdi-account-group-outline"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroDispensaPaciente"
            :items="listaDeDispensasPaciente"
            :loading="!listaDeDispensasPaciente"
            :readonly="!listaDeDispensasPaciente"
            :no-data-text="loadingAutocomplete.noDataTextDispensaPaciente"
            :search-input.sync="searchDispensaPaciente"
            @keydown="buscarDispensasPacientes"
            label="Dispensas Paciente"
            autocomplete="off"
            clearable
            prepend-icon="mdi-account-cog"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroSetor"
            :items="listaDeSetores"
            :loading="!listaDeSetores"
            :readonly="!listaDeSetores"
            :no-data-text="loadingAutocomplete.noDataTextSetor"
            label="Setores"
            autocomplete="off"
            clearable
            prepend-icon="mdi-domain"
          ></v-autocomplete>
        </v-col>

        <v-col cols="12" lg="6">
          <v-autocomplete
            v-model="formRelatorio.actionSearch.numeroDispensaSetor"
            :items="listaDeDispensasSetor"
            :loading="!listaDeDispensasSetor"
            :readonly="!listaDeDispensasSetor"
            :no-data-text="loadingAutocomplete.noDataTextDispensaSetor"
            :search-input.sync="searchDispensaSetor"
            @keydown="buscarDispensasSetores"
            label="Dispensas Setor"
            autocomplete="off"
            clearable
            prepend-icon="mdi-archive-arrow-up"
          ></v-autocomplete>
        </v-col>

        <!-- <v-expand-transition>
          <v-col cols="12" lg="12" v-if="listaDeSubestoque.length > 0">
            <v-row>
              <v-col cols="12" lg="6">
                <v-autocomplete
                  v-model="formRelatorio.actionSearch.numeroSubestoque"
                  :items="listaDeSubestoque"
                  :loading="!listaDeSubestoque.length"
                  :no-data-text="loadingAutocomplete.noDataTextSubestoque"
                  label="Subestoque"
                  autocomplete="off"
                  clearable
                  prepend-icon="mdi-file-tree"
                ></v-autocomplete>
              </v-col>

              <v-col cols="12" lg="6">
                <v-autocomplete
                  v-model="formRelatorio.actionSearch.numeroDispensaSubestoque"
                  :items="listaDeDispensasSubestoque"
                  :loading="!listaDeDispensasSubestoque.length"
                  :no-data-text="loadingAutocomplete.noDataTextDispensaSubestoque"
                  label="Dispensas Subestoque"
                  autocomplete="off"
                  clearable
                  prepend-icon="mdi-source-repository-multiple"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-col>
        </v-expand-transition> -->

        <!-- DatePicker -->
        <v-col cols="12" lg="6">
          <v-menu
            ref="menuDe"
            v-model="menuDe"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
            max-width="290px"
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="dateFormattedDe"
                label="Data de Inicio"
                autocomplete="off"
                prepend-icon="mdi-calendar-today"
                v-bind="attrs"
                v-mask="['##/##/####']"
                clearable
                @blur="dateDe = parseDate1(dateFormattedDe)"
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="dateDe"
              no-title
              @input="menuDe = false"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <!-- DatePicker ' 2 '-->
        <v-expand-x-transition>
          <v-col v-if="dateDe" cols="12" lg="6">
            <v-menu
              ref="menuAte"
              v-model="menuAte"
              :close-on-content-click="false"
              transition="scale-transition"
              offset-y
              max-width="290px"
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormattedAte"
                  label="Data de Fim"
                  autocomplete="off"
                  prepend-icon="mdi-calendar"
                  v-bind="attrs"
                  v-mask="['##/##/####']"
                  clearable
                  @blur="dateAte = parseDate2(dateFormattedAte)"
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker
                v-model="dateAte"
                no-title
                @input="menuAte = false"
              ></v-date-picker>
            </v-menu>
          </v-col>
        </v-expand-x-transition>

        <v-col cols="12" align="center">
          <v-btn
            :disabled="btnGerarRelatorio"
            width="300"
            color="#3cbc62"
            class="white--text"
            @click="gerarRelatorio"
          >
            GERAR RELATÓRIO
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <Loading :open="loading" />

    <FormRelatorio
      :isTheModalOpen="formRelatorio.isOpen"
      :modalTitleToolbar="formRelatorio.modalTitleToolbar"
      v-on:fecharModal="formRelatorioClose"
      v-on:generate-excel="saveExcel(formRelatorio.dataRelatorio)"
    >

      <v-row class="pa-4">
        <v-col cols="12">
          <v-card elevation="0">
            <v-row v-if="formRelatorio.dataRelatorio.itensDispensaPacienteAgrupado.length > 0" class="pb-16">
              <v-col cols="12">
                <DataTable
                  :tableTitle="'Produtos Dispensados para Pacientes'"
                  :tableHeader="headerItensAgrupados"
                  :tableRows="formRelatorio.dataRelatorio.itensDispensaPacienteAgrupado"
                ></DataTable>
              </v-col>
            </v-row>

            <v-card-title v-if="formRelatorio.dataRelatorio.dispensaPacientes.length > 0">• Dispensas de Pacientes - Total de Pacientes atendidos: {{formRelatorio.dataRelatorio.pacientesAtendidos}}</v-card-title>
            <v-card-title v-else>• Dispensas de Pacientes</v-card-title>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && !formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaPacientes.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(new Date().toISOString().substr(0, 10)) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaPacientes.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataFim) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataAtual && !formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dispensaPacientes.length > 0" class="pl-10 pt-3">
              <b>Dispensados na data de: {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataAtual) }}</b>
            </v-card-subtitle>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.dispensaPacientes.length > 0" cols="12">
                <DataTable
                  :tableTitle="'Dispensa de Pacientes'"
                  :tableHeader="headerDispensaPaciente"
                  :tableRows="formRelatorio.dataRelatorio.dispensaPacientes"
                ></DataTable>
              </v-col>
              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de visualizar a tabela de Dispensa de Pacientes, pois, não há dados suficientes.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row class="py-8">
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>

      <v-row class="pa-4">
        <v-col cols="12">
          <v-card elevation="0">
            <v-row v-if="formRelatorio.dataRelatorio.itensDispensaSetorAgrupado.length > 0" class="pb-16">
              <v-col cols="12">
                <DataTable
                  :tableTitle="'Produtos Dispensados para Setores'"
                  :tableHeader="headerItensAgrupados"
                  :tableRows="formRelatorio.dataRelatorio.itensDispensaSetorAgrupado"
                ></DataTable>
              </v-col>
            </v-row>

            <v-card-title v-if="formRelatorio.dataRelatorio.dispensaSetores.length > 0">• Dispensas de Setores - Total de Dispensas para Setores: {{formRelatorio.dataRelatorio.dispensasSetor}}</v-card-title>
            <v-card-title v-else>• Dispensas de Setores </v-card-title>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && !formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(new Date().toISOString().substr(0, 10)) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataFim) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataAtual && !formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados na data de: {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataAtual) }}</b>
            </v-card-subtitle>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.dispensaSetores.length > 0" cols="12">
                <DataTable
                  :tableTitle="'Dispensa de Setores'"
                  :tableHeader="headerDispensaSetor"
                  :tableRows="formRelatorio.dataRelatorio.dispensaSetores"
                ></DataTable>
              </v-col>
              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de visualizar a tabela de Dispensa de Setores, pois, não há dados suficientes.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>

      <v-row v-if="listaDeSubestoque.length > 0" class="py-8">
        <v-col cols="12">
          <v-divider />
        </v-col>
      </v-row>

      <!-- ARRUMAR DISPENSA SUBESTOQUE -->
      <!-- <v-row v-if="temSubestoque" class="pa-4">
        <v-col cols="12">
          <v-card elevation="0">
            <v-row v-if="formRelatorio.dataRelatorio.itensDispensaSubestoqueAgrupado.length > 0" class="pb-16">
              <v-col cols="12">
                <DataTable
                  :tableTitle="'Produtos Dispensados para Subestoques'"
                  :tableHeader="headerItensAgrupados"
                  :tableRows="formRelatorio.dataRelatorio.itensDispensaSubestoqueAgrupado"
                ></DataTable>
              </v-col>
            </v-row>

            <v-card-title>• Dispensas de Subestoques</v-card-title>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && !formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(new Date().toISOString().substr(0, 10)) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="!formRelatorio.dataRelatorio.dataAtual && formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dataFim && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados nas datas de {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataInicio) }} até {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataFim) }}</b>
            </v-card-subtitle>
            <v-card-subtitle v-if="formRelatorio.dataRelatorio.dataAtual && !formRelatorio.dataRelatorio.dataInicio && formRelatorio.dataRelatorio.dispensaSetores.length > 0" class="pl-10 pt-3">
              <b>Dispensados na data de: {{ _formatStringInBrazilianDateFormat(formRelatorio.dataRelatorio.dataAtual) }}</b>
            </v-card-subtitle>

            <v-row>
              <v-col v-if="formRelatorio.dataRelatorio.dispensaSubestoques.length > 0" cols="12">
                <DataTable
                  :tableTitle="'Dispensa de Subestoques'"
                  :tableHeader="headerDispensaSubestoque"
                  :tableRows="formRelatorio.dataRelatorio.dispensaSubestoques"
                ></DataTable>
              </v-col>
              <v-col v-else cols="12">
                <v-card-text>
                  <span class="text-subtitle-1 font-weight-light">Não é possível de visualizar a tabela de Dispensa de Subestoques, pois, não há dados suficientes.</span>
                </v-card-text>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row> -->
    </FormRelatorio>
  </v-container>
</template>

<script>
import axios from "../plugins/axios";
import store from "@/store/index";
import FormRelatorio from "../components/FormRelatorio";
import DataTable from "@/components/DataTable2.vue";
import { Workbook } from "exceljs";
import { saveAs } from "file-saver";
import Blob from "blob";
import Alertas from "../components/Alertas.vue";
import Loading from "../components/Loading.vue";

export default {
  components: {
    FormRelatorio,
    DataTable,
    Loading,
    Alertas
  },

  data: () => ({
    alerta: {
      texto: "",
      tipo: "",
    },

    alertaSocket: {
      texto: "",
      tipo: "",
    },

    config: {
      headers: {
        "Content-Type": "application/json",
        "x-auth-token": store.state.token,
      },
    },

    btnGerarRelatorio: false,
    isValido: true,
    loading: false,
    temSubestoque: false,

    page: 1,
    searchPaciente: null,
    searchDispensaPaciente: null,
    searchDispensaSetor: null,

    typingTimerSearchListaDP: null,
    typingDelaySearchListaDP: 2000,
    
    typingTimerSearchListaDS: null,
    typingDelaySearchListaDS: 2000,

    loadingAutocomplete: {
      noDataTextProduto: "Carregando a lista de produtos...",
      noDataTextFuncionario: "Carregando a lista de funcionarios...",
      noDataTextPaciente: "Carregando a lista de pacientes...",
      noDataTextDispensaPaciente: "Carregando a lista das dispensas de pacientes...",
      noDataTextSetor: "Carregando lista de setores...",
      noDataTextDispensaSetor: "Carregando a lista das dispensas de setores...",
      noDataTextSubestoque: "Carregando a lista de subestoque...",
      noDataTextDispensaSubestoque: "Carregando a lista das dispensas de subestoques...",
    },

    //DatePicker
    dateDe: null,
    dateAte: null,
    dateFormattedDe: null,
    dateFormattedAte: null,
    menuDe: false,
    menuAte: false,

    //formRelatorio
    formRelatorio: {
      descricaoTela: "RelatorioSaida",
      isOpen: false,
      modalTitleToolbar: "Relatório de Saida Gerado",
      actionSearch: {
        numeroEndereco: store.state.numeroEndereco,
        numeroItem: [],
        indicadorStatusFamilia: [],
        indicadorTipoDispensa: [],
        numeroFuncionario: null,
        numeroDispensaPaciente: null,
        numeroDispensaSetor: null,
        descricaoCpf: null,
        numeroSetor: null,
        numeroSubestoque: null,
        numeroDispensaSubestoque: null,
        dataAtual: null,
        dataInicio: null,
        dataFim: null,
        tipoRequisicao: "relatorio",
      },
      dataRelatorio: {
        dataAtual: null,
        dataInicio: null,
        dataFim: null,
        pacientesAtendidos: null,
        dispensasSetor: null,
        dispensaPacientes: [],
        dispensaSetores: [],
        dispensaSubestoques: [],
        itensDispensaSetorAgrupado: [],
        itensDispensaPacienteAgrupado: [],
        itensDispensaSubestoqueAgrupado: [],
        entradaItens: []
      },
    },

    //#region HEADERS
    headerItensAgrupados: [
      {
        text: "Nome do Produto",
        value: "nomeItem",
      },
      {
        text: "Quantidade Total Dispensada",
        value: "quantidadeDispensada",
      },
    ],
    headerDispensaPaciente: [
      {
        text: "Nº Dispensa",
        value: "numeroDispensaPaciente",
      },{
        text: "Nº Produto",
        value: "numeroItemDispensaPaciente",
      },
      {
        text: "Nome do Paciente",
        value: "nomePaciente",
      },
      {
        text: "Nome do Funcionario",
        value: "nomeFuncionario",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Lote do Produto",
        value: "loteItem",
      },
      {
        text: "Validade do Produto",
        value: "dataValidadeItem",
      },
      {
        text: "Família do Produto",
        value: "indicadorStatusFamilia",
      },
      {
        text: "Qt. Restante",
        value: "quantidadeItemUnidade",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeItemDispensaPaciente",
      },
      {
        text: "Tipo Dispensa",
        value: "tipoDispensa",
      },
      {
        text: "Data Dispensa",
        value: "dataDispensaPaciente",
      },
    ],
    headerDispensaSetor: [
      {
        text: "Nº Dispensa",
        value: "numeroDispensaSetor",
      },{
        text: "Nº Produto",
        value: "numeroItemDispensaSetor",
      },
      {
        text: "Nome do Setor",
        value: "nomeSetor",
      },
      {
        text: "Nome do Funcionario",
        value: "nomeFuncionario",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Lote do Produto",
        value: "loteItem",
      },
      {
        text: "Validade do Produto",
        value: "dataValidadeItem",
      },
      {
        text: "Família do Produto",
        value: "indicadorStatusFamilia",
      },
      {
        text: "Qt. Restante",
        value: "quantidadeItemUnidade",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeItemDispensaSetor",
      },
      {
        text: "Data Dispensa",
        value: "dataDispensaSetor",
      },
    ],
    headerDispensaSubestoque: [
      {
        text: "Nº Dispensa",
        value: "numeroDispensaSubestoque",
      },{
        text: "Nº Produto",
        value: "numeroItemDispensaSubestoque",
      },
      {
        text: "Nome do Subestoque",
        value: "nomeSubestoque",
      },
      {
        text: "Nome do Funcionario",
        value: "nomeFuncionario",
      },
      {
        text: "Nome do Produto",
        value: "nomeItemSistema",
      },
      {
        text: "Lote do Produto",
        value: "loteItem",
      },
      {
        text: "Validade do Produto",
        value: "dataValidadeItem",
      },
      {
        text: "Família do Produto",
        value: "indicadorStatusFamilia",
      },
      {
        text: "Qt. Restante",
        value: "quantidadeItemUnidade",
      },
      {
        text: "Qt. Dispensada",
        value: "quantidadeItemDispensaSubestoque",
      },
      {
        text: "Data Dispensa",
        value: "dataDispensaSubestoque",
      },
    ],

    headerEntradaItens:[
      {
        text: "Produto",
        value: "nomeItem"
      },
      {
        text: "Lote",
        value: "loteItem"
      },
      {
        text: "Validade",
        value: "validadeItem"
      },
      {
        text: "Unidade de Medida",
        value: "unidadeMedida"
      },
      {
        text: "Quantidade Recebida",
        value: "quantidadeEntrada"
      },
      {
        text: 'Data da entrada',
        value: 'dataDispensa'
      }
    ],
    //#endregion

    listaDeItens: null,
    listaDeFuncionarios: null,
    listaDePaciente: null,
    listaDeDispensasPaciente: null,
    listaDeSetores: null,
    listaDeDispensasSetor: null,
    listaDeSubestoque: [],
    listaDeDispensasSubestoque: [],
    listaTipoDispensa: [
      {
        value: 0,
        text: "Comum"
      },
      {
        value: 1,
        text: "UTI"
      },
      {
        value: 2,
        text: "Enfermaria"
      },
      {
        value: 3,
        text: "Centro Cirúrgico"
      },
      {
        value: 4,
        text: "SADT"
      },
      {
        value: 5,
        text: "Mandato Judicial"
      },
    ],
    listaDeFamilias: [
      {
        value: 1,
        text: "Medicações"
      },
      {
        value: 2,
        text: "Materiais"
      },
      {
        value: 3,
        text: "Psicotrópicos"
      },
      {
        value: 4,
        text: "Saneantes"
      },
      {
        value: 5,
        text: "Cosméticos"
      },
      {
        value: 6,
        text: "Nutrição"
      },
      {
        value: 7,
        text: "Antimicrobianos"
      },
      {
        value: 8,
        text: "Amostra Grátis",
      },
      {
        value: 9,
        text: "Maleta de Emergência",
      },
      {
        value: 10,
        text: "Doação",
      },
      {
        value: 11,
        text: "Teste Rápido",
      },
      {
        value: 12,
        text: "USO INTERNO"
      }
    ],
    selectedItem: null,

    rules: {
      required: (value) => value.length > 0 || "Requer o campo!",
    },
  }),

  created() {
    this.initialize();
  },

  computed: {
    computedDateFormatted1() {
      return this.formatDate1(this.dateDe);
    },
    computedDateFormatted2() {
      return this.formatDate2(this.dateAte);
    },
  },

  watch: {
    dateDe() {
      this.dateFormattedDe = this.formatDate1(this.dateDe);
      this.formRelatorio.actionSearch.dataInicio = this.dateDe
    },
    dateAte() {
      this.dateFormattedAte = this.formatDate2(this.dateAte);
      this.formRelatorio.actionSearch.dataFim = this.dateAte
    },
    isValido() {
      this.btnGerarRelatorio = !this.isValido;
    },
    searchPaciente() {
      if(!this.searchPaciente) {
        this.listaPaciente();
      }
    }
  },

  methods: {
    //#region Initialize e Listagens
    async initialize() {
      try {
        this.listaItens();
        this.listaFuncionarios();
        this.listaPaciente();
        this.listaDispensasPaciente();
        this.listaSetores();
        this.listaDispensasSetor();
        this.listaSubestoques();
        this.listaDispensasSubestoques();
      } catch (error) {
        console.log(error)
      }
    },

    async listaItens() {
      try {
        this.btnGerarRelatorio = true

        const responseItens = await axios.put("itemSistemaUnidade", {numeroEndereco: store.state.numeroEndereco}, this.config);

        if(responseItens.data.length == 0) {
          this.loadingAutocomplete.noDataTextProduto = "Não há produtos cadastrados"
        }

        this.listaDeItens = responseItens.data.map((row) => {
          return { 
            value: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            text: row.itemSistema.nomeItemSistema,
            numeroItemSistema: row.itemSistema.numeroItemSistema,
            numeroItemSistemaUnidade: row.itemSistemaUnidade.numeroItemSistemaUnidade,
            quantidadeEstoque: row.quantidadeEstoqueTotal,
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.btnGerarRelatorio = false
      }
    },

    async listaFuncionarios() {
      try {
        const responseFuncionario = await axios.get("funcionario", this.config);

        if(responseFuncionario.data.length == 0) {
          this.loadingAutocomplete.noDataTextFuncionario = "Não há funcionarios cadastrados"
        }

        this.listaDeFuncionarios = responseFuncionario.data.map((row) => {
          return { 
            value: row.numeroFuncionario,
            text: row.nomeFuncionario
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaPaciente() {
      try {
        let responsePaciente = await axios.put("listarPacientePagination", {page: this.page, search: this.searchPaciente} ,this.config);

        if(responsePaciente.data.length == 0) {
          this.loadingAutocomplete.noDataTextPaciente = "Não há pacientes cadastrados"
        }

        this.listaDePaciente = responsePaciente.data.map((pacienteSelecionado) => {
          if(pacienteSelecionado.descricaoCpf) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF: " + pacienteSelecionado.descricaoCpf,
            };
          } else if(!pacienteSelecionado.descricaoCpf && pacienteSelecionado.descricaoRG) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  RG: " + pacienteSelecionado.descricaoRG,
            };
          } else if(!pacienteSelecionado.descricaoCpf && !pacienteSelecionado.descricaoRG && pacienteSelecionado.descricaoCpfResponsavel) {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  CPF do Responsável: " + pacienteSelecionado.descricaoCpfResponsavel,
            };
          } else {
            return {
              value: pacienteSelecionado.descricaoCpf,
              text: "Nome: " + pacienteSelecionado.descricaoNome + "  |  Não há dados informados!",
            };
          }
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaDispensasPaciente() {
      try {
        this.loadingAutocomplete.dispensaPacientes = true
        const responsePaciente = await axios.put("dispensaPaciente", { numeroEndereco: store.state.numeroEndereco, page: 1, search: this.searchDispensaPaciente }, this.config);

        if(responsePaciente.data.length == 0) {
          this.loadingAutocomplete.noDataTextDispensaPaciente = "Não há dispensas de pacientes registrada"
        }

        this.listaDeDispensasPaciente = responsePaciente.data.map((row) => {
          return { 
            value: row.dispensaPaciente.numeroDispensaPaciente,
            text: 'Nº ' + row.dispensaPaciente.numeroDispensaPaciente + ' - ' + row.paciente.descricaoNome
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaSetores() {
      try {
        let responseSetor = await axios.put("setorUnidade", { numeroEndereco: store.state.numeroEndereco }, this.config);

        if(responseSetor.data.length == 0) {
          this.loadingAutocomplete.noDataTextSetor = "Não há setor cadastrado"
        }

        this.listaDeSetores = responseSetor.data.map((row) => {
          return { 
            value: row.numeroSetor,
            text: row.nomeSetor
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaDispensasSetor() {
      try {
        const responseSetor = await axios.put("dispensaSetor", { numeroEndereco: store.state.numeroEndereco, page: 1, search: this.searchDispensaSetor }, this.config);

        if(responseSetor.data.length == 0) {
          this.loadingAutocomplete.noDataTextDispensaSetor = "Não há dispensas setor registrada"
        }

        this.listaDeDispensasSetor = responseSetor.data.map((row) => {
          return { 
            value: row.numeroDispensaSetor,
            text: 'Nº ' + row.numeroDispensaSetor + ' - ' + row.nomeSetor
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaSubestoques() {
      try {
        let responseSubestoque = await axios.put("subestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        if(responseSubestoque.data.length == 0) {
          this.loadingAutocomplete.noDataTextSubestoque = "Não há subestoque cadastrado"
        }

        this.listaDeSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.numeroSubestoque,
            text: row.nomeSubestoque
          };
        });

        if(this.listaDeSubestoque.length > 0) {
          this.temSubestoque = true
        } else {
          this.temSubestoque = false
        }
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },

    async listaDispensasSubestoques() {
      try {
        const responseSubestoque = await axios.put("dispensaSubestoque", { numeroEndereco: store.state.numeroEndereco }, this.config);

        if(responseSubestoque.data.length == 0) {
          this.loadingAutocomplete.noDataTextDispensaSubestoque = "Não há dispensa de subestoque registrado"
        }

        this.listaDeDispensasSubestoque = responseSubestoque.data.map((row) => {
          return {
            value: row.dispensaSubestoque.numeroDispensaSubestoque,
            text: 'Nº ' + row.dispensaSubestoque.numeroDispensaSubestoque + ' - ' + row.subestoque.nomeSubestoque
          };
        });
      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      }
    },
    //#endregion

    async gerarRelatorio() {
      this.loading = true;
      try {
        if(!this.formRelatorio.actionSearch.dataInicio) {
          this.formRelatorio.actionSearch.dataAtual = new Date().toISOString().substr(0, 10);
        } else {
          this.formRelatorio.actionSearch.dataAtual = null;
        }
        
        const responseRelatorio = await axios.put(
          "relatorioSaida",
          this.formRelatorio.actionSearch,
          this.config
        );
        
        this.formRelatorio.dataRelatorio.dispensaPacientes = responseRelatorio.data.dispensaPaciente;
        this.formRelatorio.dataRelatorio.dispensaSetores = responseRelatorio.data.dispensaSetor;
        this.formRelatorio.dataRelatorio.dispensaSubestoques = responseRelatorio.data.dispensaSubestoque;
        this.formRelatorio.dataRelatorio.itensDispensaSetorAgrupado = responseRelatorio.data.itensDispensaSetorAgrupados;
        this.formRelatorio.dataRelatorio.itensDispensaPacienteAgrupado = responseRelatorio.data.itensDispensaPacienteAgrupados;
        this.formRelatorio.dataRelatorio.itensDispensaSubestoqueAgrupado = responseRelatorio.data.itensDispensaSubestoqueAgrupados;
        this.formRelatorio.dataRelatorio.dataAtual = responseRelatorio.data.dataAtual;
        this.formRelatorio.dataRelatorio.dataInicio = responseRelatorio.data.dataInicio;
        this.formRelatorio.dataRelatorio.dataFim = responseRelatorio.data.dataFim;
        this.formRelatorio.dataRelatorio.pacientesAtendidos = responseRelatorio.data.quantidadeAtendida;
        this.formRelatorio.dataRelatorio.dispensasSetor = responseRelatorio.data.quantidadeDispensa;

      } catch (error) {
        this.alerta.texto = error.response.data.message;
        this.alerta.tipo = "erro";
      } finally {
        this.loading = false;
        this.formRelatorio.isOpen = true;
      }
    },

    formRelatorioClose() {
      this.formRelatorio.dataRelatorio.dispensaPacientes = [];
      this.formRelatorio.dataRelatorio.dispensaSetores = [];
      this.formRelatorio.dataRelatorio.dispensaSubestoques = []
      this.formRelatorio.dataRelatorio.itensDispensaSetorAgrupado = []
      this.formRelatorio.dataRelatorio.itensDispensaPacienteAgrupado = []
      this.formRelatorio.dataRelatorio.itensDispensaSubestoqueAgrupado = []
      this.formRelatorio.dataRelatorio.dataAtual = null;
      this.formRelatorio.dataRelatorio.dataInicio = null;
      this.formRelatorio.dataRelatorio.dataFim = null;
      this.formRelatorio.dataRelatorio.pacientesAtendidos = null;
      this.formRelatorio.dataRelatorio.dispensasSetor = null;

      this.dateFormattedDe = null;
      this.dateFormattedAte = null;
      this.dateDe = null;
      this.dateAte = null;

      this.formRelatorio.isOpen = false;
    },

    removeItem(item) {
      const index = this.formRelatorio.actionSearch.numeroItem.indexOf(item.value);
      if (index >= 0)
        this.formRelatorio.actionSearch.numeroItem.splice(index, 1);
    },

    removeFamilia(item) {
      const index = this.formRelatorio.actionSearch.indicadorStatusFamilia.indexOf(item.value);
      if (index >= 0)
        this.formRelatorio.actionSearch.indicadorStatusFamilia.splice(index, 1);
    },

    removeTipo(item) {
      const index = this.formRelatorio.actionSearch.indicadorTipoDispensa.indexOf(item.value);
      if (index >= 0)
        this.formRelatorio.actionSearch.indicadorTipoDispensa.splice(index, 1);
    },

    async buscarPacientes(){ 
      await this.listaPaciente()
    },

    buscarDispensasPacientes(){ 
      clearTimeout(this.typingTimerSearchListaDP);
      this.typingTimerSearchListaDP = setTimeout(() => {
        this.listaDispensasPaciente();
      }, this.typingDelaySearchListaDP);
    },

    buscarDispensasSetores(){ 
      clearTimeout(this.typingTimerSearchListaDS);
      this.typingTimerSearchListaDS = setTimeout(() => {
        this.listaDispensasSetor();
      }, this.typingDelaySearchListaDS);
    },

    //#region FORMATERS
    formatDate1(dateDe) {
      if (!dateDe) return null;

      const [day, month, year] = dateDe.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate1(dateDe) {
      if (!dateDe) return null;
      const [day, month, year] = dateDe.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    formatDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("-");
      return `${year}/${month}/${day}`;
    },

    parseDate2(dateAte) {
      if (!dateAte) return null;
      const [day, month, year] = dateAte.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },

    _formatStringInBrazilianDateFormat(data) {
      if (!data) return 'Sem Data';
      let ano = data.split("-")[0];
      let mes = data.split("-")[1];
      let dia = data.split("-")[2];
      let dia2 = dia.substring(0, 2);

      return ("0" + dia2).slice(-2) + "/" + ("0" + mes).slice(-2) + "/" + ano;
    },

    formataFamilia(indicador) {
      switch (indicador) {
        case null: return "Não vinculado"
        case 0: return "Não vinculado"
        case 1: return "Medicações"
        case 2: return "Materiais"
        case 3: return "Psicotrópicos"
        case 4: return "Saneantes"
        case 5: return "Cosméticos"
        case 6: return "Nutrição"
        case 7: return "Antimicrobianos"
        case 8: return "Amostra Grátis"
        case 9: return "Maleta de Emergência"
        case 10: return "Doação"
        case 11: return "Teste Rápido"
        case 12: return "USO INTERNO"
      }
    },

    formataTipoDispensa(tipo) {
      switch (tipo) {
        case 0: return "Comum"
        case 1: return "UTI"
        case 2: return "Enfermaria"
        case 3: return "Centro Cirúrgico"
        case 4: return "SADT"
        case 5: return "Mandato Judicial"
      }
    },
    //#endregion

    //#region Excel
    saveExcel(conteudo) {
      try {
        const dataSelecionada = this.formRelatorio.dataRelatorio.dataInicio ? " | De " + this._formatStringInBrazilianDateFormat(this.formRelatorio.dataRelatorio.dataInicio) + " até " + (this.formRelatorio.dataRelatorio.dataFim ? this._formatStringInBrazilianDateFormat(this.formRelatorio.dataRelatorio.dataFim) : this._formatStringInBrazilianDateFormat(new Date().toISOString().substr(0, 10))) : " | " + this._formatStringInBrazilianDateFormat(this.formRelatorio.actionSearch.dataAtual);

        const workbook = new Workbook();

        var borderStyles = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        
        //#region PRODUTOS AGRUPADOS
        var worksheetItensAgrupados = workbook.addWorksheet("Produtos Agrupados", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheetItensAgrupados.columns = [
          { key: "col1", width: 80 },
          { key: "col2", width: 30 },
        ];

        let posicaoItensAgrupados = 1;
        worksheetItensAgrupados.mergeCells('A'+posicaoItensAgrupados+':B'+posicaoItensAgrupados);
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Produtos Dispensados para Pacientes' + dataSelecionada;
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 14, bold: true };
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'center' };
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'66cc99'},
        };
        posicaoItensAgrupados++

        if(conteudo.itensDispensaPacienteAgrupado.length > 0) {
          const headerTableSetor = worksheetItensAgrupados.addRow({
            col1: "Nome do Produto",
            col2: "Quantidade Total Dispensada"
          });
          headerTableSetor.font = {
            name: "Calibri",
            size: 12,
            bold: true,
            color: { argb: "262626" },
          };
          headerTableSetor.alignment = { vertical: "top", horizontal: "center" };
          posicaoItensAgrupados++

          let totalDispensadoPacienteAgrupado = 0;
          conteudo.itensDispensaPacienteAgrupado.map((dispensaSelecionada) => {
            worksheetItensAgrupados.addRow({
              col1: dispensaSelecionada.nomeItem,
              col2: dispensaSelecionada.quantidadeDispensada,
            }).alignment = { vertical: "top", horizontal: "left" };
            posicaoItensAgrupados++
            
            totalDispensadoPacienteAgrupado = (parseInt(dispensaSelecionada.quantidadeDispensada) + totalDispensadoPacienteAgrupado);
          });
          
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Total Dispensado: ';
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 12, bold: true };
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'right' };
          
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).value = totalDispensadoPacienteAgrupado;
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 12, bold: false };
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoItensAgrupados++
        } else {
          worksheetItensAgrupados.mergeCells('A'+posicaoItensAgrupados+':B'+posicaoItensAgrupados);
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Não é possível de visualizar a tabela de Produtos Dispensados para Pacientes, pois, não há dados suficientes.';
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 13, bold: false };
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'center' };
          posicaoItensAgrupados++
        }

        posicaoItensAgrupados++
        posicaoItensAgrupados++
        posicaoItensAgrupados++

        worksheetItensAgrupados.mergeCells('A'+posicaoItensAgrupados+':B'+posicaoItensAgrupados);
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Produtos Dispensados para Setores' + dataSelecionada;
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 14, bold: true };
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'center' };
        worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'66cc99'},
        };
        posicaoItensAgrupados++

        if(conteudo.itensDispensaSetorAgrupado.length > 0) {
          const headerTableSetor = worksheetItensAgrupados.addRow({
            col1: "Nome do Produto",
            col2: "Quantidade Total Dispensada"
          });
          headerTableSetor.font = {
            name: "Calibri",
            size: 12,
            bold: true,
            color: { argb: "262626" },
          };
          headerTableSetor.alignment = { vertical: "top", horizontal: "center" };
          posicaoItensAgrupados++
  
          let totalDispensadoSetorAgrupado = 0;
          conteudo.itensDispensaSetorAgrupado.map((dispensaSelecionada) => {
            worksheetItensAgrupados.addRow({
              col1: dispensaSelecionada.nomeItem,
              col2: dispensaSelecionada.quantidadeDispensada,
            }).alignment = { vertical: "top", horizontal: "left" };
            posicaoItensAgrupados++
            
            totalDispensadoSetorAgrupado = (parseInt(dispensaSelecionada.quantidadeDispensada) + totalDispensadoSetorAgrupado);
          });
          
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Total Dispensado: ';
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 12, bold: true };
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'right' };
          
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).value = totalDispensadoSetorAgrupado;
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 12, bold: false };
          worksheetItensAgrupados.getCell('B'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoItensAgrupados++
        } else {
          worksheetItensAgrupados.mergeCells('A'+posicaoItensAgrupados+':B'+posicaoItensAgrupados);
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).value = 'Não é possível de visualizar a tabela de Produtos Dispensados para Setores, pois, não há dados suficientes.';
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).font = { name: 'Arial', family: 2, size: 13, bold: false };
          worksheetItensAgrupados.getCell('A'+posicaoItensAgrupados).alignment = { vertical: 'middle', horizontal: 'center' };
          posicaoItensAgrupados++
        }
        
        worksheetItensAgrupados.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });
        //#endregion

        //#region DISPENSA PACIENTE
        var worksheetDispensaPaciente = workbook.addWorksheet("Dispensas de Pacientes", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheetDispensaPaciente.columns = [
          { key: "col1", width: 20 },
          { key: "col2", width: 20 },
          { key: "col3", width: 40 },
          { key: "col4", width: 30 },
          { key: "col5", width: 60 },
          { key: "col6", width: 25 },
          { key: "col7", width: 20 },
          { key: "col8", width: 30 },
          { key: "col9", width: 20 },
          { key: "col10", width: 20 },
          { key: "col11", width: 20 },
          { key: "col12", width: 20 },
          { key: "col13", width: 20 },
        ];

        let posicaoLinhaDispensaPaciente = 1;
        worksheetDispensaPaciente.mergeCells('A'+posicaoLinhaDispensaPaciente+':M'+posicaoLinhaDispensaPaciente);
        if(conteudo.dispensaPacientes.length > 0) {
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).value = 'Dispensas de Pacientes - Total de Pacientes atendidos: ' + conteudo.pacientesAtendidos + dataSelecionada;

        } else {
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).value = 'Dispensas de Pacientes' + dataSelecionada;
        }
        worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).font = { name: 'Arial', family: 2, size: 14, bold: true };
        worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
        worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'66cc99'},
        };
        posicaoLinhaDispensaPaciente++

        if(conteudo.dispensaPacientes.length > 0) {
          const headerTablePaciente = worksheetDispensaPaciente.addRow({
            col1: "Nº Dispensa",
            col2: "Nº Produto",
            col3: "Nome do Paciente",
            col4: "Data de nascimento",
            col5: "Nome do Funcionario",
            col6: "Nome do Produto",
            col7: "Lote do Produto",
            col8: "Validade do Produto",
            col9: "Família do Produto",
            col10: "Data Dispensa",
            col11: "Tipo Dispensa",
            col12: "Qt. Restante",
            col13: "Qt. Dispensada",
          });
          headerTablePaciente.font = {
            name: "Calibri",
            size: 12,
            bold: true,
            color: { argb: "262626" },
          };
          headerTablePaciente.alignment = { vertical: "top", horizontal: "center" };
          posicaoLinhaDispensaPaciente++
  
          let totalDispensadoPaciente = 0;
          conteudo.dispensaPacientes.map((dispensaSelecionada) => {
            worksheetDispensaPaciente.addRow({
              col1: dispensaSelecionada.numeroDispensaPaciente,
              col2: dispensaSelecionada.numeroItemDispensaPaciente,
              col3: dispensaSelecionada.nomePaciente,
              col4: this._formatStringInBrazilianDateFormat(dispensaSelecionada.dataNascimentoPaciente),
              col5: dispensaSelecionada.nomeFuncionario,
              col6: dispensaSelecionada.nomeItemSistema,
              col7: dispensaSelecionada.loteItem,
              col8: dispensaSelecionada.dataValidadeItem,
              col9: this.formataFamilia(dispensaSelecionada.indicadorStatusFamilia),
              col10: this._formatStringInBrazilianDateFormat(dispensaSelecionada.dataDispensaPaciente),
              col11: this.formataTipoDispensa(dispensaSelecionada.tipoDispensa),
              col12: dispensaSelecionada.quantidadeItemUnidade,
              col13: dispensaSelecionada.quantidadeItemDispensaPaciente,
            
            }).alignment = { vertical: "top", horizontal: "left" };
            posicaoLinhaDispensaPaciente++

            totalDispensadoPaciente = (parseInt(dispensaSelecionada.quantidadeItemDispensaPaciente) + totalDispensadoPaciente);
          });
          
          worksheetDispensaPaciente.mergeCells('A'+posicaoLinhaDispensaPaciente+':K'+posicaoLinhaDispensaPaciente);
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).value = 'Total Dispensado: ';
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).font = { name: 'Arial', family: 2, size: 12, bold: true };
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).alignment = { vertical: 'middle', horizontal: 'right' };

          worksheetDispensaPaciente.getCell('L'+posicaoLinhaDispensaPaciente).value = totalDispensadoPaciente;
          worksheetDispensaPaciente.getCell('L'+posicaoLinhaDispensaPaciente).font = { name: 'Arial', family: 2, size: 12, bold: false };
          worksheetDispensaPaciente.getCell('L'+posicaoLinhaDispensaPaciente).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoLinhaDispensaPaciente++
        } else {
          worksheetDispensaPaciente.mergeCells('A'+posicaoLinhaDispensaPaciente+':L'+posicaoLinhaDispensaPaciente);
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).value = 'Não é possível de visualizar a tabela de Dispensa de Pacientes, pois, não há dados suficientes.';
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).font = { name: 'Arial', family: 2, size: 13, bold: false };
          worksheetDispensaPaciente.getCell('A'+posicaoLinhaDispensaPaciente).alignment = { vertical: 'middle', horizontal: 'center' };
          posicaoLinhaDispensaPaciente++
        }

        worksheetDispensaPaciente.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });
        //#endregion

        //#region DISPENSA SETOR
        var worksheetDispensaSetor = workbook.addWorksheet("Dispensas de Setores", {
          properties: { tabColor: { argb: "FF00FF00" } },
          views: [{ showGridLines: false }],
        });

        worksheetDispensaSetor.columns = [
          { key: "col1", width: 20 },
          { key: "col2", width: 20 },
          { key: "col3", width: 40 },
          { key: "col4", width: 30 },
          { key: "col5", width: 60 },
          { key: "col6", width: 25 },
          { key: "col7", width: 20 },
          { key: "col8", width: 30 },
          { key: "col9", width: 20 },
          { key: "col10", width: 20 },
          { key: "col11", width: 20 },
        ];

        let posicaoLinhaDispensaSetor = 1;
        worksheetDispensaSetor.mergeCells('A'+posicaoLinhaDispensaSetor+':K'+posicaoLinhaDispensaSetor);
        if(conteudo.dispensaSetores.length > 0) {
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).value = 'Dispensas de Setores - Total de Dispensas: ' + conteudo.dispensasSetor + dataSelecionada;
        
        } 
        else {
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).value = 'Dispensas de Setores' +  dataSelecionada;        
        }
        
        worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).font = { name: 'Arial', family: 2, size: 14, bold: true };
        worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).alignment = { vertical: 'middle', horizontal: 'center' };
        worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).fill = {
          type: 'pattern',
          pattern:'solid',
          fgColor:{argb:'66cc99'},
        };
        posicaoLinhaDispensaSetor++

        if(conteudo.dispensaSetores.length > 0) {
          const headerTableSetor = worksheetDispensaSetor.addRow({
            col1: "Nº Dispensa",
            col2: "Nº Produto",
            col3: "Nome do Setor",
            col4: "Nome do Funcionario",
            col5: "Nome do Produto",
            col6: "Lote do Produto",
            col7: "Validade do Produto",
            col8: "Família do Produto",
            col9: "Data Dispensa",
            col10: "Qt. Restante",
            col11: "Qt. Dispensada",
        
          });
          headerTableSetor.font = {
            name: "Calibri",
            size: 12,
            bold: true,
            color: { argb: "262626" },
          };
          headerTableSetor.alignment = { vertical: "top", horizontal: "center" };
          posicaoLinhaDispensaSetor++
  
          let totalDispensadoSetores = 0;
          conteudo.dispensaSetores.map((dispensaSelecionada) => {
            worksheetDispensaSetor.addRow({
              col1: dispensaSelecionada.numeroDispensaSetor,
              col2: dispensaSelecionada.numeroItemDispensaSetor,
              col3: dispensaSelecionada.nomeSetor,
              col4: dispensaSelecionada.nomeFuncionario,
              col5: dispensaSelecionada.nomeItemSistema,
              col6: dispensaSelecionada.loteItem,
              col7: dispensaSelecionada.dataValidadeItem,
              col8: this.formataFamilia(dispensaSelecionada.indicadorStatusFamilia),
              col9: this._formatStringInBrazilianDateFormat(dispensaSelecionada.dataDispensaSetor),
              col10: dispensaSelecionada.quantidadeItemUnidade,
              col11: dispensaSelecionada.quantidadeItemDispensaSetor,
            }).alignment = { vertical: "top", horizontal: "left" };
            posicaoLinhaDispensaSetor++
            
            totalDispensadoSetores = (parseInt(dispensaSelecionada.quantidadeItemDispensaSetor) + totalDispensadoSetores);
          });
          
          worksheetDispensaSetor.mergeCells('A'+posicaoLinhaDispensaSetor+':J'+posicaoLinhaDispensaSetor);
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).value = 'Total Dispensado: ';
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).font = { name: 'Arial', family: 2, size: 12, bold: true };
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).alignment = { vertical: 'middle', horizontal: 'right' };
          
          worksheetDispensaSetor.getCell('K'+posicaoLinhaDispensaSetor).value = totalDispensadoSetores;
          worksheetDispensaSetor.getCell('K'+posicaoLinhaDispensaSetor).font = { name: 'Arial', family: 2, size: 12, bold: false };
          worksheetDispensaSetor.getCell('K'+posicaoLinhaDispensaSetor).alignment = { vertical: 'middle', horizontal: 'left' };
          posicaoLinhaDispensaSetor++
        } else {
          worksheetDispensaSetor.mergeCells('A'+posicaoLinhaDispensaSetor+':K'+posicaoLinhaDispensaSetor);
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).value = 'Não é possível de visualizar a tabela de Dispensa de Setores, pois, não há dados suficientes.';
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).font = { name: 'Arial', family: 2, size: 13, bold: false };
          worksheetDispensaSetor.getCell('A'+posicaoLinhaDispensaSetor).alignment = { vertical: 'middle', horizontal: 'center' };
          posicaoLinhaDispensaSetor++
        }
        
        worksheetDispensaSetor.eachRow({ includeEmpty: true }, function(row) {
          row.eachCell({ includeEmpty: true }, function(cell) {
            cell.border = borderStyles;
          });
        });
        //#endregion

        workbook.xlsx.writeBuffer().then(function(data) {
          var blob = new Blob([data], {
            type:
              "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });
          saveAs(blob, "Relatorio de Saida.xlsx");
        });

        this.rowPosition = 0;
      } catch (error) {
        console.log(error);
      }
    },
    //#endregion

  },
};
</script>
